import ManagerDiscoveryPlaceDetails from './ManagerDiscoveryPlaceDetails.container';

export default ManagerDiscoveryPlaceDetails;
